// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3z7fk","insightsList":"newBusinessInsightsMenu_insightsList__1D9cF","active":"newBusinessInsightsMenu_active__3bHYW"};